import Vue from 'vue'
import Router from 'vue-router'

import home from '@/view/home'
import index from '@/view/index'
import indexForStore from '@/view/indexForStore'
import indexForDefault from '@/view/indexForDefault'
import login from '@/view/login'
const customerManage = r => require.ensure([], () => r(require('@/view/客户管理/客户管理')), 'customerManage');
const customerDetail = r => require.ensure([], () => r(require('@/view/客户管理/客户详情')), 'customerDetail');

const commodityCard = r => require.ensure([], () => r(require('@/view/卡券管理/卡劵列表')), 'commodityCard');
const commodityCardAdd = r => require.ensure([], () => r(require('@/view/卡券管理/新增卡劵')), 'commodityCardAdd');
const commodityCardUpdate = r => require.ensure([], () => r(require('@/view/卡券管理/编辑卡劵')), 'commodityCardUpdate');
const commodityCardDetail = r => require.ensure([], () => r(require('@/view/卡券管理/查看卡券')), 'commodityCardDetail');
const cardCancellation = r => require.ensure([], () => r(require('@/view/卡券管理/卡劵核销')), 'cardCancellation');
const cardCancellationList = r => require.ensure([], () => r(require('@/view/卡券管理/卡劵核销(平台端)')), 'cardCancellationList');

const businessShopList = r => require.ensure([], () => r(require('@/view/商品管理/入驻商商品列表')), 'businessShopList');
const platformShopList = r => require.ensure([], () => r(require('@/view/商品管理/平台自营商品列表')), 'platformShopList');
const addShop = r => require.ensure([], () => r(require('@/view/商品管理/添加商品')), 'addShop');
const shopTypeManage = r => require.ensure([], () => r(require('@/view/商品管理/商品分类管理')), 'shopTypeManage');
const shopTypeAdd = r => require.ensure([], () => r(require('@/view/商品管理/新建分类')), 'shopTypeAdd');
const shopTypeEdit = r => require.ensure([], () => r(require('@/view/商品管理/分类编辑')), 'shopTypeEdit');
const shopTypeDetail = r => require.ensure([], () => r(require('@/view/商品管理/分类详情')), 'shopTypeDetail');
const shopCommentManage = r => require.ensure([], () => r(require('@/view/商品管理/商品评论管理')), 'shopCommentManage');
const shopCommentDetail = r => require.ensure([], () => r(require('@/view/商品管理/评论详情')), 'shopCommentDetail');
const shopCommentAdd = r => require.ensure([], () => r(require('@/view/商品管理/新增评论')), 'shopCommentAdd');
const platformInventoryWarning = r => require.ensure([], () => r(require('@/view/商品管理/平台自营库存预警')), 'platformInventoryWarning');
const editShop = r => require.ensure([], () => r(require('@/view/商品管理/编辑商品')), 'editShop');
const shopDetails = r => require.ensure([], () => r(require('@/view/商品管理/商品详情')), 'shopDetails');

const businessOrderManage = r => require.ensure([], () => r(require('@/view/订单管理/入驻商订单列表')), 'businessOrderManage');
const platformOrderManage = r => require.ensure([], () => r(require('@/view/订单管理/平台自营订单列表')), 'platformOrderManage');
const orderDetail = r => require.ensure([], () => r(require('@/view/订单管理/订单详情')), 'orderDetail');
const InvoiceDetail = r => require.ensure([], () => r(require('@/view/订单管理/发货单详情')), 'InvoiceDetail');
const businessInvoice = r => require.ensure([], () => r(require('@/view/订单管理/入驻商发货单')), 'businessInvoice');
const platformInvoice = r => require.ensure([], () => r(require('@/view/订单管理/平台自营发货单')), 'platformInvoice');
const businessRefund = r => require.ensure([], () => r(require('@/view/订单管理/入驻商退款、退货')), 'businessRefund');
const platformRefund = r => require.ensure([], () => r(require('@/view/订单管理/平台自营退款、退货')), 'platformRefund');
const businessRefundDetail = r => require.ensure([], () => r(require('@/view/订单管理/入驻商退款、退货详情')), 'businessRefundDetail');
const platformRefundDetail = r => require.ensure([], () => r(require('@/view/订单管理/平台自营退款、退货详情')), 'platformRefundDetail');
const orderRemind = r => require.ensure([], () => r(require('@/view/订单管理/订单提醒')), 'orderRemind');

const bannerManage = r => require.ensure([], () => r(require('@/view/页面发布系统/banner管理')), 'bannerManage');
const bannerAdd = r => require.ensure([], () => r(require('@/view/页面发布系统/新增banner')), 'bannerAdd');
const bannerEdit = r => require.ensure([], () => r(require('@/view/页面发布系统/编辑banner')), 'bannerEdit');
const articleManage = r => require.ensure([], () => r(require('@/view/页面发布系统/文章管理')), 'articleManage');
const articleAdd = r => require.ensure([], () => r(require('@/view/页面发布系统/新增文章')), 'articleAdd');
const articleEdit = r => require.ensure([], () => r(require('@/view/页面发布系统/编辑文章')), 'articleEdit');
const specialManage = r => require.ensure([], () => r(require('@/view/页面发布系统/专题管理')), 'specialManage');
const specialAdd = r => require.ensure([], () => r(require('@/view/页面发布系统/新增专题')), 'specialAdd');
const specialEdit = r => require.ensure([], () => r(require('@/view/页面发布系统/编辑专题')), 'specialEdit');
const activityManage = r => require.ensure([], () => r(require('@/view/页面发布系统/活动管理')), 'activityManage');
const activityAndOrder = r => require.ensure([], () => r(require('@/view/页面发布系统/活动添加和订单管理')), 'activityAndOrder');
const activityAdd = r => require.ensure([], () => r(require('@/view/页面发布系统/新增活动')), 'activityAdd');
const activityEdit = r => require.ensure([], () => r(require('@/view/页面发布系统/编辑活动')), 'activityEdit');
const activityDetail = r => require.ensure([], () => r(require('@/view/页面发布系统/活动详情')), 'activityDetail');
const activityOrderManage = r => require.ensure([], () => r(require('@/view/页面发布系统/活动订单管理')), 'activityOrderManage');
const activityOrderDetail = r => require.ensure([], () => r(require('@/view/页面发布系统/活动订单详情')), 'activityOrderDetail');

const residentList = r => require.ensure([], () => r(require('@/view/入驻商管理/入驻商列表')), 'residentList');
const residentAdd = r => require.ensure([], () => r(require('@/view/入驻商管理/添加入驻商')), 'residentAdd');
const residentEdit = r => require.ensure([], () => r(require('@/view/入驻商管理/编辑入驻商')), 'residentEdit');

const commoditySuitList = r => require.ensure([], () => r(require('@/view/商品套装管理/商品套装列表')), 'commoditySuitList');
const commoditySuitAdd = r => require.ensure([], () => r(require('@/view/商品套装管理/新增商品套装')), 'commoditySuitAdd');
const commoditySuitDedail = r => require.ensure([], () => r(require('@/view/商品套装管理/查看商品套装')), 'commoditySuitDedail');
const commoditySuitUpdate = r => require.ensure([], () => r(require('@/view/商品套装管理/编辑商品套装')), 'commoditySuitUpdate');

const freightTemplateList = r => require.ensure([], () => r(require('@/view/运费模板/运费模板列表')), 'commoditySuitUpdate');
const freightTemplateAdd = r => require.ensure([], () => r(require('@/view/运费模板/新建运费模板')), 'freightTemplateAdd');
const freightTemplateEdit = r => require.ensure([], () => r(require('@/view/运费模板/编辑运费模板')), 'freightTemplateEdit');

const platformFlowDetail = r => require.ensure([], () => r(require('@/view/报表系统/平台流水明细')), 'platformFlowDetail');
const businessSettlementStatistics = r => require.ensure([], () => r(require('@/view/报表系统/商家结算统计')), 'businessSettlementStatistics');
const revenueStatistics = r => require.ensure([], () => r(require('@/view/报表系统/营收统计')), 'revenueStatistics');
const cardSettlement = r => require.ensure([], () => r(require('@/view/报表系统/卡券结算统计')), 'cardSettlement');

const systemBasicsSet = r => require.ensure([], () => r(require('@/view/系统管理/平台基础设置')), 'systemBasicsSet');
const adminAdd = r => require.ensure([], () => r(require('@/view/系统管理/新增管理员')), 'adminAdd');
const adminLog = r => require.ensure([], () => r(require('@/view/系统管理/管理员日志')), 'adminLog');
const adminManage = r => require.ensure([], () => r(require('@/view/系统管理/管理员管理')), 'adminManage');
const adminDetail = r => require.ensure([], () => r(require('@/view/系统管理/管理员编辑')), 'adminDetail');



const roleAdd = r => require.ensure([], () => r(require('@/view/系统管理/角色新增')), 'roleAdd');
const roleManage = r => require.ensure([], () => r(require('@/view/系统管理/角色管理')), 'roleManage');
const roleDetail = r => require.ensure([], () => r(require('@/view/系统管理/角色编辑')), 'roleDetail');



const cashRecords = r => require.ensure([], () => r(require('@/view/结算管理/提现明细')), 'cashRecords');
const cashDetail = r => require.ensure([], () => r(require('@/view/结算管理/提现详情')), 'cashDetail');
const drainageRecords = r => require.ensure([], () => r(require('@/view/结算管理/结算明细')), 'drainageRecords');
const settleManage = r => require.ensure([], () => r(require('@/view/结算管理/结算标准管理')), 'settleManage');
const newfeeAdd = r => require.ensure([], () => r(require('@/view/结算管理/新增稿费')), 'newfeeAdd');
const feeDetail = r => require.ensure([], () => r(require('@/view/结算管理/咨询费详情')), 'feeDetail');
const feeDetailforPay = r => require.ensure([], () => r(require('@/view/结算管理/费用详情')), 'feeDetailforPay');

const doctorList = r => require.ensure([], () => r(require('@/view/医生管理/医生管理')), 'doctorList');
const doctorDetail = r => require.ensure([], () => r(require('@/view/医生管理/医生详情')), 'doctorDetail');
const doctorAdd = r => require.ensure([], () => r(require('@/view/医生管理/新增医生')), 'doctorAdd');


const answerDetail = r => require.ensure([], () => r(require('@/view/答疑管理/答疑详情')), 'answerDetail');
const newDepartment = r => require.ensure([], () => r(require('@/view/答疑管理/新建科室')), 'newDepartment');
const addTopics = r => require.ensure([], () => r(require('@/view/答疑管理/添加新话题')), 'addTopics');
const departmentList = r => require.ensure([], () => r(require('@/view/答疑管理/答疑科室管理')), 'departmentList');
const departmentDetail = r => require.ensure([], () => r(require('@/view/答疑管理/科室详情')), 'departmentDetail');
const editDepartment = r => require.ensure([], () => r(require('@/view/答疑管理/编辑科室')), 'editDepartment');


const contentList = r => require.ensure([], () => r(require('@/view/内容管理/内容管理')), 'contentList');
const addContent = r => require.ensure([], () => r(require('@/view/内容管理/添加新分类')), 'addContent');
const contentDetail = r => require.ensure([], () => r(require('@/view/内容管理/内容详情')), 'contentDetail');
const editContent = r => require.ensure([], () => r(require('@/view/内容管理/内容编辑')), 'editContent');
const publishContent = r => require.ensure([], () => r(require('@/view/内容管理/发布内容')), 'publishContent');
const contentclassify = r => require.ensure([], () => r(require('@/view/内容管理/内容分类管理')), 'contentclassify');
const contentclassifyDetail = r => require.ensure([], () => r(require('@/view/内容管理/内容分类详情')), 'contentclassifyDetail');
const contentclassifyEdit = r => require.ensure([], () => r(require('@/view/内容管理/内容分类编辑')), 'contentclassifyEdit');



const reservationDetail = r => require.ensure([], () => r(require('@/view/预约管理/预约详情')), 'reservationDetail');
const addDepartment = r => require.ensure([], () => r(require('@/view/预约管理/添加科室')), 'addDepartment');
const reservationList = r => require.ensure([], () => r(require('@/view/预约管理/预约管理')), 'reservationList');
const reservationDepartment = r => require.ensure([], () => r(require('@/view/预约管理/预约科室管理')), 'reservationDepartment');
const reservationDepartmentDetail = r => require.ensure([], () => r(require('@/view/预约管理/预约科室详情')), 'reservationDepartmentDetail');
const editreservationDepartment = r => require.ensure([], () => r(require('@/view/预约管理/编辑预约科室')), 'editreservationDepartment');


const doctorActivityList = r => require.ensure([], () => r(require('@/view/活动管理/活动管理')), 'doctorActivityList');
const newActivity = r => require.ensure([], () => r(require('@/view/活动管理/新增活动')), 'newActivity');
const seeDetail = r => require.ensure([], () => r(require('@/view/活动管理/查看详情')), 'seeDetail');
const editActivityDoctor = r => require.ensure([], () => r(require('@/view/活动管理/编辑活动')), 'editActivityDoctor');
const answerList = r => require.ensure([], () => r(require('@/view/答疑管理/答疑管理')), 'answerList');
const bannerDoctor = r => require.ensure([], () => r(require('@/view/服务页面管理/服务banner管理')), 'bannerDoctor');
const addBanner = r => require.ensure([], () => r(require('@/view/服务页面管理/新增医生端banner')), 'addBanner');
const EditBannerDoctor = r => require.ensure([], () => r(require('@/view/服务页面管理/编辑医生端banner')), 'EditBannerDoctor');
const conversation = r => require.ensure([], () => r(require('@/view/答疑管理/话题管理')), 'conversation');
const conversationDetail = r => require.ensure([], () => r(require('@/view/答疑管理/话题详情')), 'conversationDetail');
const conversationEdit = r => require.ensure([], () => r(require('@/view/答疑管理/编辑话题')), 'conversationEdit');


const noticeList = r => require.ensure([], () => r(require('@/view/服务页面管理/通知公告管理')), 'noticeList');
const addNotice = r => require.ensure([], () => r(require('@/view/服务页面管理/新增公告')), 'addNotice');
const Editnotice = r => require.ensure([], () => r(require('@/view/服务页面管理/编辑公告')), 'Editnotice');

const feedbackList = r => require.ensure([], () => r(require('@/view/服务页面管理/反馈管理')), 'feedbackList');
const feedbackDetail = r => require.ensure([], () => r(require('@/view/服务页面管理/反馈详情')), 'feedbackDetail');


const adsList = r => require.ensure([], () => r(require('@/view/客户档案管理/ads-list')), 'adsList');
const customerList = r => require.ensure([], () => r(require('@/view/客户档案管理/customer-list')), 'customerList');



Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      name: 'login',
      component: login,
      hidden: true,
    },
    {
      path: '/',
      component: home,
      name: '首页',
      hidden: false,
      leaf: true,
      iconCls: 'iconfont icon-icon_home',//图标样式class
      meta: {},
      module: 'first',
      children: [
        {path: "/index", component: index,  permission: 'index'},
      ]
    },
    {
      path: '/',
      component: home,
      name: '首页',
      hidden: false,
      leaf: true,
      iconCls: 'iconfont icon-icon_home',//图标样式class
      meta: {},
      module: 'first',
      permission:'storeIndex',
      children: [
        {path: "/indexForStore", component: indexForStore, permission: 'storeIndex'}
      ]
    },
    {
      path: '/',
      component: home,
      name: '首页',
      hidden: false,
      leaf: true,
      iconCls: 'iconfont icon-icon_home',//图标样式class
      meta: {},
      module: 'first',
      children: [
        {path: "/indexForDefault", component: indexForDefault}
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      hidden: true,
    },
    {
      path: '/',
      component: home,
      name: '客户管理',
      hidden: false,
      iconCls: 'iconfont icon-yonghuzhongxin',//图标样式class
      meta: {},
      module: 'first',
      permission:'commodityManage',
      children: [
        {path: '/customerList', component: customerList, name: '客户管理', permission:'businessCommodityManage', meta: {keepAlive: true},},
        {path: '/adsList', component: adsList, name: '推送文章管理', permission:'businessCommodityManage', meta: {keepAlive: true},},
      ]
    },
    {
      path: '/',
      component: home,
      name: '商品管理',
      hidden: false,
      iconCls: 'iconfont el-icon-goods',//图标样式class
      meta: {},
      module: 'first',
      permission:'commodityManage',
      children: [
        // {path: '/businessShopList', component: businessShopList, name: '入驻商商品列表', permission:'storeManage',meta: {keepAlive: true}, },
        {path: '/platformShopList', component: platformShopList, name: '商品列表', permission:'businessCommodityManage',meta: {keepAlive: true}, },
        {path: '/businessShopList', component: businessShopList, name: '我的商品列表', permission:'myCommodityManage',meta: {keepAlive: true}, },


        {path: '/addBusinessShop', hidden: true, from: '/businessShopList', component: addShop, name: '添加商品', meta: {keepAlive: false}},
        {path: '/addPlatformShop', hidden: true, from: '/platformShopList', component: addShop, name: '添加商品',meta: {keepAlive: false}},
        {path: '/editBusinessShop', hidden: true, from: '/businessShopList', component: editShop, name: '编辑商品',meta: {keepAlive: false}},
        {path: '/editPlatformShop', hidden: true, from: '/platformShopList', component: editShop, name: '编辑商品',meta: {keepAlive: false}},
        {path: '/businessShopDetails', hidden: true, from: '/businessShopList', component: shopDetails, name: '商品详情',meta: {keepAlive: false}},
        {path: '/platformShopDetails', hidden: true, from: '/platformShopList', component: shopDetails, name: '商品详情',meta: {keepAlive: false}},

        {path: '/shopTypeManage', component: shopTypeManage, name: '分类管理',  permission:'shopTypeManage',meta: {keepAlive: true}},
        {path: '/shopTypeAdd', hidden: true, from: '/shopTypeManage', component: shopTypeAdd, name: '新建分类',meta: {keepAlive: false}},
        {path: '/shopTypeEdit', hidden: true, from: '/shopTypeManage', component: shopTypeEdit, name: '分类编辑',meta: {keepAlive: false}},
        {path: '/shopTypeDetail', hidden: true, from: '/shopTypeManage', component: shopTypeDetail, name: '分类详情',meta: {keepAlive: false}},
        {path: '/shopCommentManage', component: shopCommentManage, name: '评论管理', permission:'shopCommentManage',meta: {keepAlive: true}},
        {path: '/shopCommentDetail', hidden: true, from: '/shopCommentManage', component: shopCommentDetail, name: '新建分类',meta: {keepAlive: false}},
        {path: '/shopCommentAdd', hidden: true, from: '/shopCommentManage', component: shopCommentAdd, name: '新建评论',meta: {keepAlive: false}},
        {path: '/platformInventoryWarning', component: platformInventoryWarning, name: '库存预警',permission:'platformInventoryWarning',meta: {keepAlive: false}, },
        {path: '/platformInventoryWarning', component: platformInventoryWarning, name: '我的库存预警',permission:'ownInventoryWarning',meta: {keepAlive: false}, },
      ]
    },
    {
      path: '/',
      component: home,
      name: '订单管理',
      hidden: false,
      iconCls: 'iconfont el-icon-printer',//图标样式class
      meta: {},
      module: 'first',
      permission:'orderManage',
      children: [
        // {path: '/businessOrderManage', component: businessOrderManage, name: '入驻商订单列表', permission:'businessmanOrderManage',meta: {keepAlive: true}},
        {path: '/platformOrderManage', component: platformOrderManage, name: '订单列表', permission:'storeOrderManage',meta: {keepAlive: true}},
        {path: '/platformOrderManage', component: platformOrderManage, name: '我的订单列表', permission:'businessOrderManage',meta: {keepAlive: true}},
        // {path: '/businessOrderDetail', hidden: true, from: '/businessOrderManage', component: orderDetail, name: '入驻商订单详情',meta: {keepAlive: false}},
        {path: '/platformOrderDetail', hidden: true, from: '/platformOrderManage', component: orderDetail, name: '订单详情',meta: {keepAlive: false}},
        // {path: '/businessInvoice', component: businessInvoice, name: '入驻商发货单', permission:'businessmanBill',meta: {keepAlive: true}},
        {path: '/businessInvoice', component: businessInvoice, name: '我的发货单',permission:'businessBill',meta: {keepAlive: true}},
        {path: '/platformInvoice', component: platformInvoice, name: '发货列表', permission:'storeBill',meta: {keepAlive: true}},
        // {path: '/businessInvoiceDetail', hidden: true, from: '/businessInvoice', component: InvoiceDetail, name: '入驻商发货单详情',meta: {keepAlive: false}},
        {path: '/platformInvoiceDetail', hidden: true, from: '/platformInvoice', component: InvoiceDetail, name: '发货单详情',meta: {keepAlive: false}},
        // {path: '/businessRefund', component: businessRefund, name: '入驻商退款、退货', permission:'businessmanRefund',meta: {keepAlive: true}},
        {path: '/businessRefund', component: businessRefund, name: '退款、退货', permission:'businessRefund',meta: {keepAlive: true}},
        {path: '/platformRefund', component: platformRefund, name: '退款、退货', permission:'storeRefund',meta: {keepAlive: true}},
        // {path: '/businessRefundDetail', hidden: true, from: '/businessRefund', component: businessRefundDetail, name: '入驻商退款、退货详情',meta: {keepAlive: false}},
        {path: '/platformRefundDetail', hidden: true, from: '/platformRefund', component: platformRefundDetail, name: '退款、退货详情',meta: {keepAlive: false}},
        {path: '/orderRemind', component: orderRemind, name: '订单提醒', permission:'index',meta: {keepAlive: true}},
      ]
    },
    {
      path: '/',
      component: home,
      name: '页面管理',
      hidden: false,
      iconCls: 'iconfont icon-gaojianfabu',//图标样式class
      meta: {},
      module: 'first',
      permission:'pagePublication',
      children: [
        {path: '/bannerManage', component: bannerManage, name: '轮播图管理',  permission:'bannerManage',meta: {keepAlive: true}},
        // {path: '/bannerManage', component: bannerManage, name: '商铺banner管理', permission:'bannerManageForbusiness',meta: {keepAlive: true}},
        {path: '/bannerAdd', hidden: true, from: '/bannerManage', component: bannerAdd, name: '新增banner',meta: {keepAlive: false}},
        {path: '/bannerEdit', hidden: true, from: '/bannerManage', component: bannerEdit, name: '编辑banner',meta: {keepAlive: false}},
        {path: '/articleManage', component: articleManage, name: '文章管理',  permission:'articleManage',meta: {keepAlive: true}},
        {path: '/articleAdd', hidden: true, from: '/articleManage', component: articleAdd, name: '新增文章',meta: {keepAlive: false}},
        {path: '/articleEdit', hidden: true, from: '/articleManage', component: articleEdit, name: '编辑文章',meta: {keepAlive: false}},
        // {path: '/specialManage', component: specialManage, name: '专题管理',  permission:'topicManage',meta: {keepAlive: true}},
        {path: '/specialAdd', hidden: true, from: '/specialManage', component: specialAdd, name: '新增专题',meta: {keepAlive: false}},
        {path: '/specialEdit', hidden: true, from: '/specialManage', component: specialEdit, name: '编辑专题',meta: {keepAlive: false}},
        // {path: '/activityManage', component: activityManage, name: '活动管理', permission:'activityManage',meta: {keepAlive: true}},
        {path: '/activityAdd', hidden: true, from: '/activityManage', component: activityAdd, name: '新增活动',meta: {keepAlive: false}},
        {path: '/activityEdit', hidden: true, from: '/activityManage', component: activityEdit, name: '编辑活动',meta: {keepAlive: false}},
        {path: '/activityDetail', hidden: true, from: '/activityManage', component: activityDetail, name: '活动详情',meta: {keepAlive: false}},
        {path: '/activityAndOrder', hidden: true, from: '/activityManage', component: activityAndOrder, name: '订单管理',meta: {keepAlive: true}},
        {path: '/activityEdit', hidden: true, from: '/activityManage', component: activityEdit, name: '编辑活动',meta: {keepAlive: false}},
        // {path: '/activityOrderManage', hidden: false, from: '/activityManage', component: activityOrderManage, name: '活动订单管理', permission:'activityOrderManage',meta: {keepAlive: true}},
        {path: '/activityOrderDetail', hidden: true, from: '/activityManage', component: activityOrderDetail, name: '活动订单详情',meta: {keepAlive: false}},
      ]
    },
    // {
    //   path: '/',
    //   component: home,
    //   name: '入驻商管理',
    //   hidden: false,
    //   iconCls: 'iconfont el-icon-sold-out',//图标样式class
    //   meta: {},
    //   module: 'first',
    //   permission:'businessmanManage',
    //   children: [
    //     {path: '/residentList', component: residentList, name: '入驻商列表', permission:'businessmanList',meta: {keepAlive: true}},
    //     {path: '/residentAdd', hidden: true, from: '/residentList', component: residentAdd, name: '添加入驻商' ,meta: {keepAlive: false}},
    //     {path: '/residentEdit', hidden: true, from: '/residentList', component: residentEdit, name: '编辑入驻商' ,meta: {keepAlive: false}},
    //   ]
    // },
    {
      path: '/',
      component: home,
      name: '运费模板',
      hidden: false,
      iconCls: 'iconfont icon-setting-permissions',//图标样式class
      meta: {},
      module: 'first',
      permission:'templateFreight',
      children: [
        {path: '/freightTemplateList', component: freightTemplateList, name: '运费模板',  permission:'templateFreightList',meta: {keepAlive: true}},
        {path: '/freightTemplateAdd', hidden: true, from: '/freightTemplateList', component: freightTemplateAdd, name: '新建运费模板' ,meta: {keepAlive: false}},
        {path: '/freightTemplateEdit', hidden: true, from: '/freightTemplateList', component: freightTemplateEdit, name: '编辑运费模板',meta: {keepAlive: false}},
      ]
    },
    // {
    //   path: '/',
    //   component: home,
    //   name: '卡券管理',
    //   hidden: false,
    //   iconCls: ' fa fa-credit-card-alt',//图标样式class
    //   meta: {},
    //   module: 'first',
    //   permission:'cardManage',
    //   children: [
    //     {path: '/commodityCard', component: commodityCard, name: '卡券列表',  permission:'cardList',meta: {keepAlive: true}},
    //     {path: '/commodityCardAdd', hidden: true, from: '/commodityCard', component: commodityCardAdd, name: '新建卡券' ,meta: {keepAlive: false}},
    //     {path: '/commodityCardUpdate', hidden: true, from: '/commodityCard', component: commodityCardUpdate, name: '编辑卡券' ,meta: {keepAlive: false}},
    //     {path: '/commodityCardDetail', hidden: true, from: '/commodityCard', component: commodityCardDetail, name: '查看卡券' ,meta: {keepAlive: false}},
    //     {path: '/cardCancellation', component: cardCancellation, name: '卡券核销',  permission:'cardCancellation',meta: {keepAlive: true}},
    //     {path: '/cardCancellationList', component: cardCancellationList, name: '卡券核销列表',  permission:'cardCancellationList',meta: {keepAlive: true}},
    //   ]
    // },
    // {
    //   path: '/',
    //   component: home,
    //   name: '商品套装管理',
    //   hidden: false,
    //   iconCls: 'fa fa-suitcase',//图标样式class
    //   meta: {},
    //   module: 'first',
    //   permission:'commoditySuitManage',
    //   children: [
    //     {path: '/commoditySuitList', component: commoditySuitList, name: '商品套装列表',  permission:'suitList',meta: {keepAlive: true}},
    //     {path: '/commoditySuitAdd', hidden: true, from: '/commoditySuitList', component: commoditySuitAdd, name: '新建商品套装' ,meta: {keepAlive: false}},
    //     {path: '/commoditySuitDedail',  hidden: true, from: '/commoditySuitList', component: commoditySuitDedail, name: '查看商品套装' ,meta: {keepAlive: false}},
    //     {path: '/commoditySuitUpdate',  hidden: true, from: '/commoditySuitList', component: commoditySuitUpdate, name: '编辑商品套装' ,meta: {keepAlive: false}},

    //   ]
    // },
    {
      path: '/',
      component: home,
      name: '报表系统',
      hidden: false,
      iconCls: 'iconfont icon-icon-fuwuguanli',//图标样式class
      meta: {},
      module: 'first',
      permission:'reportingSystem',
      children: [
        {path: '/platformFlowDetail', component: platformFlowDetail, name: '平台流水明细',meta: {keepAlive: false}, permission:'funds'},
        // {path: '/businessSettlementStatistics', component: businessSettlementStatistics, name: '商家结算统计',meta: {keepAlive: false}, permission:'statisticsFunds'},
        {path: '/revenueStatistics', component: revenueStatistics, name: '营收统计',meta: {keepAlive: false}, permission:'revenueStatistics'},
        // {path: '/cardSettlement', component: cardSettlement, name: '卡券结算统计',meta: {keepAlive: false}, permission:'reportingSystem'},
      ]
    },
    {
      path: '/',
      component: home,
      name: '系统管理',
      hidden: false,
      iconCls: 'iconfont icon-settings21',//图标样式class
      meta: {},
      module: 'first',
      permission:'systemManage',
      children: [
        // {path: '/systemBasicsSet', component: systemBasicsSet, name: '基础设置',meta: {keepAlive: false}, permission:'storeManage'},
        // {path: '/systemBasicsSet', component: systemBasicsSet, name: '店铺基础设置',meta: {keepAlive: false}, permission:'storeManage'},
        {path: '/adminAdd', component: adminAdd, name: '新增管理员',meta: {keepAlive: false}, permission:'managerAdd'},
        {path: '/adminLog', component: adminLog, name: '管理员日志',meta: {keepAlive: false}, permission:'managerLog'},
        {path: '/adminManage', component: adminManage, name: '管理员管理', permission:'managerManage',meta: {keepAlive: true}},
        {path: '/adminDetail', hidden: true, from: '/adminManage', component: adminDetail, name: '管理员编辑',meta: {keepAlive: false}},
        {path: '/roleAdd', hidden: true, component: roleAdd, name: '角色新增',meta: {},permission:'managerLog'},
        {path: '/roleManage', component: roleManage, name: '角色管理', permission:'roleManage',meta: {}},
        {path: '/roleDetail', hidden: true,  component: roleDetail, name: '角色编辑',meta: {}},

      ]
    },
    {
      path: '/',
      component: home,
      name: '结算管理',
      hidden: false,
      iconCls: 'fa fa-money',//图标样式class
      meta: {},
      module: 'third',
      permission:'settlementManage',
      children: [
        {path: '/cashRecords', component: cashRecords, name: '提现明细',  permission:'drawMoneyDetail',meta: {keepAlive: true}},
        {path: '/cashDetail', hidden: true, from: '/cashRecords', component: cashDetail, name: '客户详情',meta: {keepAlive: false}},
        {path: '/drainageRecords', component: drainageRecords, name: '结算明细',  permission:'popularizeDetail',meta: {keepAlive: true}},
        {path: '/settleManage', component: settleManage, name: '结算标准管理',  permission:'settlementStandard',meta: {keepAlive: true}},
        {path: '/newfeeAdd',hidden: true, component: newfeeAdd, name: '新增费用',  permission:'settlementStandard',meta: {keepAlive: true}},
        {path: '/feeDetailforPay',hidden: true, component: feeDetailforPay, name: '费用详情',  permission:'settlementStandard',meta: {keepAlive: true}},
        {path: '/feeDetail',hidden: true, component: feeDetail, name: '咨询费详情',  permission:'settlementStandard',meta: {keepAlive: true}},
      ]
    },
    {
      path: '/',
      component: home,
      name: '医生管理',
      hidden: false,
      iconCls: 'fa fa-medkit',//图标样式class
      meta: {},
      module: 'fourth',
      permission:'doctorManage',
      children: [
        {path: '/doctorList', component: doctorList, name: '医生管理', permission:'doctorManageList',meta: {keepAlive: true} },
        {path: '/doctorDetail', hidden: true, from: '/doctorList', component: doctorDetail, name: '医生详情',meta: {keepAlive: false}},
        {path: '/doctorAdd', hidden: true, from: '/doctorList', component: doctorAdd, name: '新增医生',meta: {keepAlive: false}},
      ]
    },{
      path: '/',
      component: home,
      name: '答疑管理',
      hidden: false,
      iconCls: 'fa fa-medkit',//图标样式class
      meta: {},
      module: 'second',
      permission:'answerQuestionManage',
      children: [
        {path: '/answerList', component: answerList, name: '答疑管理', permission:'answerQuestionList',meta: {keepAlive: true} },
        {path: '/departmentList', component: departmentList, name: '答疑科室管理', permission:'answerQuestionDepart',meta: {keepAlive: true} },
        {path: '/conversationEdit',hidden: true, component: conversationEdit, name: '编辑话题',meta: {keepAlive: true} },
        {path: '/editDepartment',hidden: true, component: editDepartment, name: '编辑科室',meta: {keepAlive: true} },
        {path: '/departmentDetail',hidden: true, component: departmentDetail, name: '科室详情',meta: {keepAlive: true} },
        {path: '/answerDetail',hidden: true, component: answerDetail, name: '答疑详情',meta: {keepAlive: true} },
        {path: '/newDepartment', hidden: true, from: '/doctorList', component: newDepartment  , name: '新建科室',meta: {keepAlive: false}},
        {path: '/conversation', component: conversation, name: '话题管理', permission:'conversationManage',meta: {keepAlive: true} },
        {path: '/conversationDetail', hidden: true,component: conversationDetail, name: '话题详情',meta: {keepAlive: true} },
        {path: '/addTopics', hidden: true, from: '/doctorList', component: addTopics  , name: '添加新话题',meta: {keepAlive: false}},
      ]
    },{
      path: '/',
      component: home,
      name: '内容管理',
      hidden: false,
      iconCls: 'fa fa-medkit',//图标样式class
      meta: {},
      module: 'second',
      permission:'contentManage',
      children: [
        {path: '/contentList',hidden: false, component: contentList, name: '内容列表', permission:'contentList',meta: {keepAlive: true} },

        {path: '/contentclassify',hidden: false, component: contentclassify, name: '内容分类管理', permission:'contentTypeList',meta: {keepAlive: true} },

        {path: '/contentDetail',hidden: true, component: contentDetail, name: '内容详情',meta: {keepAlive: true} },
        {path: '/addContent',hidden: true, component: addContent, name: '添加新分类',meta: {keepAlive: true} },
        {path: '/editContent',hidden: true, component: editContent, name: '内容编辑',meta: {keepAlive: true} },
        {path: '/contentclassifyEdit',hidden: true, component: contentclassifyEdit, name: '内容分类详情',meta: {keepAlive: true} },
        {path: '/contentclassifyDetail',hidden: true, component: contentclassifyDetail, name: '内容分类详情',meta: {keepAlive: true} },

        {path: '/publishContent',hidden: true, component: publishContent, name: '发布内容',meta: {keepAlive: true} },
      ]
    },{
      path: '/',
      component: home,
      name: '预约管理',
      hidden: false,
      iconCls: 'fa fa-medkit',//图标样式class
      meta: {},
      module: 'second',
      permission:'reservationManage',
      children: [
        {path: '/reservationList',hidden: false, component: reservationList, name: '预约列表', permission:'reservationList',meta: {keepAlive: true} },


        {path: '/reservationDepartment',hidden: false, component: reservationDepartment, name: '预约科室管理', permission:'reservationDepartment',meta: {keepAlive: true} },

        {path: '/reservationDetail',hidden: true, component: reservationDetail, name: '预约详情',meta: {keepAlive: true} },
        {path: '/addDepartment',hidden: true, component: addDepartment, name: '添加科室',meta: {keepAlive: true} },
        {path: '/reservationDepartmentDetail',hidden: true, component: reservationDepartmentDetail, name: '预约科室详情',meta: {keepAlive: true} },
        {path: '/editreservationDepartment',hidden: true, component: editreservationDepartment, name: '编辑预约科室',meta: {keepAlive: true} },
      ]
    },{
      path: '/',
      component: home,
      name: '活动管理',
      hidden: false,
      iconCls: 'fa fa-medkit',//图标样式class
      meta: {},
      module: 'second',
      permission:'doctorActivityManage',
      children: [
        {path: '/doctorActivityList', component: doctorActivityList, name: '活动管理', permission:'doctorActivityList',meta: {keepAlive: true} },
        {path: '/newActivity',hidden: true, component: newActivity, name: '新增活动',meta: {keepAlive: true} },
        {path: '/editActivityDoctor',hidden: true, component: editActivityDoctor, name: '编辑活动',meta: {keepAlive: true} },
        {path: '/seeDetail',hidden: true, component: seeDetail, name: '查看详情',meta: {keepAlive: true} },
      ]
    },

    {
      path: '/',
      component: home,
      name: '服务页面管理',
      hidden: false,
      iconCls: 'fa fa-medkit',//图标样式class
      meta: {},
      module: 'second',
      permission:'servicePageManage',
      children: [
        {path: '/bannerDoctor', component: bannerDoctor, name: '服务banner管理', permission:'serviceBannerList',meta: {keepAlive: true} },
        {path: '/addBanner',hidden: true, component: addBanner, name: '新增医生端banner',meta: {keepAlive: true} },
        {path: '/EditBannerDoctor',hidden: true, component: EditBannerDoctor, name: '编辑医生端banner',meta: {keepAlive: true} },
        {path: '/noticeList', component: noticeList, name: '通知公告管理', permission:'noticeAnnouncementManage',meta: {keepAlive: true} },
        {path: '/addNotice',hidden: true, component: addNotice, name: '新增公告',meta: {keepAlive: true} },
        {path: '/Editnotice',hidden: true, component: Editnotice, name: '编辑公告',meta: {keepAlive: true} },
        {path: '/feedbackList', component: feedbackList, name: '反馈管理', permission:'feedbackManage',meta: {keepAlive: true} },
        {path: '/feedbackDetail',hidden: true, component: feedbackDetail, name: '编辑公告',meta: {keepAlive: true} },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js